import PropTypes from 'prop-types'
import React from 'react'

function ActiveLine() {
  return (
    <div
      className="absolute flex align-center items-center align-middle content-center"
      style={{
        width: 'calc(100% - 2.5rem - 1rem)',
        top: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    >
      <div className="w-full bg-gray-200 rounded items-center align-middle align-center flex-1">
        <div
          className="w-0 bg-blue-300 py-1 rounded"
          style={{ width: '100%' }}
        />
      </div>
    </div>
  )
}

function InactiveLine() {
  return (
    <div
      className="absolute flex align-center items-center align-middle content-center"
      style={{
        width: 'calc(100% - 2.5rem - 1rem)',
        top: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    >
      <div className="w-full bg-gray-200 rounded items-center align-middle align-center flex-1">
        <div className="w-0 bg-blue-300 py-1 rounded" style={{ width: '0%' }} />
      </div>
    </div>
  )
}

function StepLine({ activeStep, stepIndex }) {
  if (stepIndex <= 0) {
    return null
  }

  return stepIndex < activeStep ? <ActiveLine /> : <InactiveLine />
}

function CurrentIcon({ icon }) {
  return (
    <div className="w-10 h-10 mx-auto bg-blue-100 border-4 border-blue-500 rounded-full text-lg text-white flex items-center">
      <span className="text-center text-white w-full">{icon}</span>
    </div>
  )
}

function ActiveIcon({ icon }) {
  return (
    <div className="w-10 h-10 mx-auto bg-blue-500 rounded-full text-lg text-white flex items-center">
      <span className="text-center text-white w-full">{icon}</span>
    </div>
  )
}

function InactiveIcon({ icon }) {
  return (
    <div className="w-10 h-10 mx-auto bg-white border-2 border-gray-200 rounded-full text-lg text-white flex items-center">
      <span className="text-center text-gray-600 w-full">{icon}</span>
    </div>
  )
}

function StepIcon({ activeStep, stepIndex, icon }) {
  if (activeStep === stepIndex + 1) {
    return <CurrentIcon icon={icon} />
  }

  return stepIndex < activeStep ? (
    <ActiveIcon icon={icon} />
  ) : (
    <InactiveIcon icon={icon} />
  )
}

function Wizard({ steps, activeStep }) {
  return (
    <div className="w-full py-6">
      <div className="flex">
        {steps.map((s, i) => (
          <div className="w-1/4" key={`${i}-${s.label}`}>
            <div className="relative mb-2">
              <StepLine activeStep={activeStep} stepIndex={i} />
              <StepIcon activeStep={activeStep} icon={s.icon} stepIndex={i} />
            </div>
            <div className="text-xs text-center md:text-base">{s.label}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

Wizard.defaultProps = {
  steps: [],
  activeStep: 0,
}

Wizard.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string,
      icon: PropTypes.node,
    })
  ).isRequired,
  activeStep: PropTypes.number.isRequired,
}

export default React.memo(Wizard)
